<template>
	<div class="container__registers">
		<ContentHeader>
			<SubHeader :title="title" />
		</ContentHeader>
		<ContentBody>
			<Card>
				<router-view />
			</Card>
		</ContentBody>
	</div>
</template>

<script>
import Card from '../../components/Card/Card'
import ContentBody from '../../components/ContentBody/ContentBody'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import SubHeader from '../../components/SubHeader/SubHeader'
import i18n from '../../VueI18n'

export default {
	components: { Card, ContentBody, ContentHeader, SubHeader },
	data: () => {
		return {
			activeRoute: '',
			labelAndLinkName: [
				{
					label: i18n.t('appSettings'),
					linkName: 'configuracoesaplicativo',
				},
				{
					label: i18n.t('users'),
					linkName: 'usuarios',
				},
				{
					label: i18n.t('accessProfile'),
					linkName: 'perfildeacesso',
				},
			],
		}
	},
	computed: {
		title() {
			return `${this.$t('settings')} / ${this.label}`
		},
		label() {
			return this.labelAndLinkName.filter((f) => f.linkName === this.activeRoute)[0].label
		},
	},
	watch: {
		$route(to) {
			this.activeRoute = to.name
		},
	},
	created() {
		this.activeRoute = this.$route.name
	},
}
</script>
